export function OfflinePage() {
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-6 safe-top safe-bottom">
      <div className="text-center text-white max-w-sm">
        <div className="text-6xl mb-4">📴</div>
        <h1 className="text-2xl font-bold mb-2">Sin conexión</h1>
        <p className="text-white/70 mb-6">
          Estás trabajando offline. Los cambios que hagas se guardarán y se sincronizarán cuando vuelvas a tener señal.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-2.5 rounded-lg bg-primary text-white font-semibold"
        >
          Reintentar
        </button>
      </div>
    </div>
  );
}